import { Injectable, inject } from '@angular/core';
import { ICourse } from './models/courses.model';
import { FiltersConfig, IFilterQueryResponse, TOAST_ALERTS_TOKEN, HttpCoreService } from '@dataclouder/ngx-core';

const server = 'primary';
// TODO add your own end points
const Endpoints = {
  Courses: {
    Courses: 'api/courses',
    CoursesFiltered: 'api/courses/query',
  },
};

@Injectable({
  providedIn: 'root',
})
export class CourseService {
  private httpService = inject(HttpCoreService);
  private toastService = inject(TOAST_ALERTS_TOKEN);

  public async getCourses(): Promise<ICourse[]> {
    try {
      const response = await this.httpService.get<ICourse[]>(Endpoints.Courses.Courses, server);
      this.toastService.success({ title: 'Se han encontrado generics', subtitle: 'Mostrando información' });
      return response;
    } catch (error) {
      this.toastService.warn({ title: 'Error fetching generics', subtitle: 'Showing Default Data' });
      // return RemoveSimpleDataExample;
      return [];
    }
  }

  public async getFilteredCourses(filter: FiltersConfig) {
    return this.httpService.post<IFilterQueryResponse<ICourse>>(Endpoints.Courses.CoursesFiltered, filter, server);
  }

  public async getCourse(id: string): Promise<ICourse> {
    return this.httpService.get<ICourse>(`${Endpoints.Courses.Courses}/${id}`);
  }

  public async saveCourse(course: ICourse): Promise<ICourse> {
    return this.httpService.post<ICourse>(Endpoints.Courses.Courses, course);
  }

  public async deleteCourse(id: string) {
    return this.httpService.delete(`${Endpoints.Courses.Courses}/${id}`);
  }
}
